import { render } from "./ExtrasTable.vue?vue&type=template&id=61c98ab6&scoped=true"
import script from "./ExtrasTable.vue?vue&type=script&lang=js"
export * from "./ExtrasTable.vue?vue&type=script&lang=js"

import "./ExtrasTable.vue?vue&type=style&index=0&id=61c98ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c98ab6"]])

export default __exports__